import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import { loadingActions } from '~/store';
// ---- internal imports -----

import { LEVEL_COMPLETED, LEVEL_GO_TO_NEW_LEVEL } from '../actionTypes';
// ---- parent imports -----

const onLoadedNextLevel = (action$) => action$.pipe(
	ofType(LEVEL_GO_TO_NEW_LEVEL),
	map((action) =>
		action.isLoadingNewLevel
			? start()
			: end()
	)
);

function start(){
	return async (dispatch, getState) => {
		dispatch(loadingActions.start(LEVEL_COMPLETED));
	};
}

function end(){
	return async (dispatch, getState) => {
		dispatch(loadingActions.end(LEVEL_COMPLETED));
	};
}


export default onLoadedNextLevel;
